import React, { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppState, initialAppState } from "./appState";
import apis from "../common/apis";

type LogoutContextType = {
  logout: () => void;
};

const LogoutContext = createContext<LogoutContextType | null>(null);

export const LogoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const nav = useNavigate();
  const {appState, setAppState } = useAppState();
  
  const logout = async () => {
    
        await localStorage.removeItem("appState");
        await setAppState({}); 
        // localStorage도 삭제
  }


  // 전역에서 logout을 사용할 수 있도록 window 객체에 할당 (인터셉터 등에서 호출 가능)
  useEffect(() => {
    (window as any).__GLOBAL_LOGOUT__ = logout;
    return () => {
      delete (window as any).__GLOBAL_LOGOUT__;
    };
  }, [logout]);

  return (
    <LogoutContext.Provider value={{ logout }}>
      {children}
    </LogoutContext.Provider>
  );
};

